import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertService } from "src/app/services/alert.service";
import { BookingService } from "src/app/services/booking.service";
import { FarmerService } from "src/app/services/farmer.service";
import { UserSessionService } from "src/app/services/usersession.service";
import { RoleType } from "src/enum/roletype";

@Component({
  selector: "app-remarks-popup",
  templateUrl: "./remarks-popup.component.html",
  styleUrls: ["./remarks-popup.component.scss"],
})
export class AeRemarksPopupComponent implements OnInit {
  item: any;
  form: FormGroup;
  currentDate: any;
  roleId: number;
  public roleEnum = RoleType;
  hourList: any[] = [];
  filterHourList: any[] = [];
  timeValidation: boolean;
  workCompletedTime: any;
  timeValidation1: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
    public dialogRef: MatDialogRef<AeRemarksPopupComponent>,
    private formBuilder: FormBuilder,
    private farmerService: FarmerService,
    private bookingService: BookingService,
    private usersession: UserSessionService,
    private alertService: AlertService
  ) {
    this.item = this.dataRecievedToAdd.item;

    this.roleId = this.usersession.roleId();
  }

  ngOnInit(): void {
    this.initialValidators();
    this.hourList = [
      { key: 0, value: "00" },
      { key: 15, value: "15" },
      { key: 30, value: "30" },
      { key: 45, value: "45" },
    ];
    this.filterHourList = this.hourList.slice();

    this.form.valueChanges.subscribe(() => {
      const isRemarksRequired = this.form.value.hour >= this.item?.totalHireHrs;
      if (this.form.value.hour > this.item?.totalHireHrs) {
        this.form.controls["hour"].setValue("");
        // this.form.controls['minites'].setValue('')
        this.timeValidation = true;
      } else if (this.form.value.hour > this.item?.totalHireHrs) {
        this.form.controls["hour"].setValue("");
        // this.form.controls['minites'].setValue('')
        this.timeValidation = true;
      } else {
        this.timeValidation = false;
      }
    });
    this.form.valueChanges.subscribe(() => {
      const maxDays = this.item?.totalHireHrs / 12;
      const selectedDays = this.form.value.days;

      if (selectedDays > maxDays) {
        this.form.get("days")?.setValue("");
        this.timeValidation1 = true; // show validation message
      } else {
        this.timeValidation1 = false;
      }
    });
  }

  initialValidators() {
    this.form = this.formBuilder.group({
      hour: ["", [Validators.required]],
      minites: [0, Validators.required],
      remarks: ["", Validators.required],
      // days: ['', [Validators.required]]
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  // formatNumber(num: number): string {
  //     return num < 10 ? `0${num}` : `${num}`;
  // }

  formatedDate() {
    const hours = this.formatNumber(this.form.value.hour);
    return `${hours}:00:00`;
  }

  timeConverter(time: any): string {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    let result = "";
    if (hours) {
      result += `${hours} hours`;
    }
    if (minutes) {
        result += ` ${minutes} minites`;
    }
    return result.trim();
  }

  onSave() {
    if (this.form.valid) {
      let data = {
        phireBookingId: Number(this.item.id),
        workCompletedTime: this.formatedDate1(),
        remarks: this.form.value.remarks,
      };
      this.bookingService.aeworkcompletesave(data).subscribe((res) => {
        if (res && res.isSuccess) {
          this.dialogRef.close(true);
        } else {
          this.alertService.error(res.htmlFormattedFailures);
        }
      });
    } else {
      this.form.markAllAsTouched();
    }
  }
  formatToTime(days: number): string {
    const d = Math.floor(days); // day part
    const h = "00";
    const m = "00";
    const s = "00";
    return `${d}.${h}:${m}:${s}`;
  }
  onSaveData() {
    if (!(!this.item?.vehicleCategoryName && this.item?.implementName)) {
      this.form.controls["days"].clearValidators();
      this.form.controls["days"].updateValueAndValidity();
    }

    if (!this.item?.vehicleCategoryName && this.item?.implementName) {
      this.form.controls["hour"].clearValidators();
      this.form.controls["hour"].updateValueAndValidity();
      this.form.controls["remarks"].clearValidators();
      this.form.controls["remarks"].updateValueAndValidity();
    }
    this.workCompletedTime =
      this.item?.implementName && !this.item?.vehicleCategoryName
        ? this.formatToTime(this.form.value.days)
        : this.formatedDate();
    if (this.form.valid) {
      let data = {
        phireBookingId: Number(this.item.id),
        workCompletedTime: this.workCompletedTime,
        remarks: this.form.value.remarks,
      };
      this.bookingService.focsrworkcompletesave(data).subscribe((res) => {
        if (res && res.isSuccess) {
          this.dialogRef.close(true);
        } else {
          this.alertService.error(res.htmlFormattedFailures);
        }
      });
    } else {
      this.form.markAllAsTouched();
    }
  }
  formatNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  formatedDate1() {
    return (
      this.formatNumber(this.form.value.hour) +
      ":" +
      this.formatNumber(this.form.value.minites) +
      ":00"
    );
  }
}
